import {
  ViewportBannerConsts,
} from 'client/util/Constants';
import AccountConstants from 'client/util/Constants/AccountConstants';
import PastDueAccountFirstWarningBannerSlot from 'client/components/ViewportBanner/PastDueAccountFirstWarningBannerSlot.vue';

const { accountsReceivable } = AccountConstants;

const pastDueAccountFirstWarningBannerConfig = user => ({
  name: 'pastDueAccountFirstWarningBanner',
  bannerText: '',
  childComponent: PastDueAccountFirstWarningBannerSlot,
  bannerType: ViewportBannerConsts.types.error,
  bannerVisibility: () => !user.isAnMsp
    && user.accountsReceivable === accountsReceivable.WARNING,
  canCloseBanner: false,
});

export default pastDueAccountFirstWarningBannerConfig;
